import {
  RecruiteeOpenQuestion,
  recruiteeAllowedMimeTypes,
} from "@/ats/recruitee";
import { exhaustiveSwitchGuard } from "@/lib/util";

export default function RecruiteeOpenQuestion({
  question,
}: {
  question: RecruiteeOpenQuestion;
}) {
  const htmlId = `open_question_${question.id}`;
  const labelClass = `form_col form_question`;

  return (
    <div className={labelClass}>
      <label htmlFor={htmlId}>
        <span>{question.body}</span>
        {question.required && <span aria-label="required">*</span>}
      </label>
      <input
        type="hidden"
        name={`candidate[open_question_answers_attributes][${
          question.position - 1
        }][open_question_id]`}
        value={question.id}
      />
      {(() => {
        switch (question.kind) {
          case "boolean":
            return (
              <div className="label_group radio_group">
                <label>
                  <input
                    type="radio"
                    name={`candidate[open_question_answers_attributes][${
                      question.position - 1
                    }][flag]`}
                    required={question.required}
                    value="true"
                  />{" "}
                  <b></b>
                  <span>Ja</span>
                </label>
                <label>
                  <input
                    type="radio"
                    name={`candidate[open_question_answers_attributes][${
                      question.position - 1
                    }][flag]`}
                    required={question.required}
                    value="false"
                  />{" "}
                  <b></b>
                  <span>Nee</span>
                </label>
              </div>
            );
          case "string":
            return (
              <input
                type="text"
                name={`candidate[open_question_answers_attributes][${
                  question.position - 1
                }][content]`}
                id={htmlId}
                required={question.required}
              />
            );
          case "file":
            return (
              <input
                type="file"
                name={`candidate[open_question_answers_attributes][${
                  question.position - 1
                }][file]`}
                id={htmlId}
                required={question.required}
                accept={recruiteeAllowedMimeTypes.join(",")}
              />
            );
          case "text":
            return (
              <textarea
                name={`candidate[open_question_answers_attributes][${
                  question.position - 1
                }][content]`}
                id={htmlId}
                required={question.required}
              ></textarea>
            );
          case "single_choice":
            return (
              <select
                name={`candidate[open_question_answers_attributes][${
                  question.position - 1
                }][content]`}
                id={htmlId}
                required={question.required}
              >
                {question.open_question_options.map((o) => (
                  <option value={o.body} key={o.id}>
                    {o.body}
                  </option>
                ))}
              </select>
            );
          case "multi_choice":
            return (
              <div className="label_group checkbox_group">
                {question.open_question_options.map((o) => (
                  <label key={o.id}>
                    <input
                      type="checkbox"
                      name={`candidate[open_question_answers_attributes][${
                        question.position - 1
                      }][multi_content][]`}
                      value={o.body}
                    />{" "}
                    <b></b>
                    <span>{o.body}</span>
                  </label>
                ))}
              </div>
            );
          case "legal":
            return (
              <div className="label_group checkbox_group">
                <label>
                  <input
                    type="checkbox"
                    name={`candidate[open_question_answers_attributes][${
                      question.position - 1
                    }][flag]`}
                    required={question.required}
                    value="true"
                  />{" "}
                  <b></b>
                  <span>Akkoord</span>
                </label>
              </div>
            );
          default:
            exhaustiveSwitchGuard(question.kind);
            return null;
        }
      })()}
    </div>
  );
}
